<template>
  <div class="right_col" role="main">
    <div class="row">
      <div class="col-md-12 col-sm-6 col-xs-12">
        <div class="title_left">
          <h3>派車單</h3>
          <hr />
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <!--派車資料-->
      <Dispatch :transaction="transaction" />
      <!--司機資料-->
      <Driver :driver="driver" />
      <!--乘客資料-->
      <Passenger :transaction="transaction" :passenger="passenger" />
      <!--詢車資料-->
      <Inquiry :inquiry="inquiry" />
    </div>
    <div class="col-md-6">
      <div class="row">
        <!--綜合資料-->
        <Combine :transaction="transaction" @onException="onException" />
        <!--乘車路線圖-->
        <div class="col-md-12">
          <div class="x_panel">
            <div class="x_title">
              <h4>乘車路線圖</h4>
            </div>
            <div class="row">
              <div class="col-md-5 main_title">
                <i style="color: brown" class="fa fa-taxi fa-2x"></i>
                <span class="fontSize14">乘客預計上車地點</span>
              </div>
              <div class="col-md-5 main_title">
                <i style="color: khaki" class="fa fa-taxi fa-2x"></i>
                <span class="fontSize14">乘客預計下車地點</span>
              </div>
              <div class="col-md-5 main_title">
                <i class="fa fa-taxi fa-2x"></i>
                <span class="fontSize14">定點</span>
                <div class="icontimetext">
                  {{ transaction.send_arriver_message_time }}
                </div>
              </div>
              <div class="col-md-5 main_title">
                <i style="color: darkMagenta" class="fa fa-taxi fa-2x"></i>
                <span class="fontSize14">司機接單地點</span>
                <div class="icontimetext">{{ transaction.order_time }}</div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-5 main_title">
                <i style="color: seaGreen" class="fa fa-taxi fa-2x"></i>
                <span class="fontSize14">接到地點</span>
                <div class="icontimetext">
                  {{ transaction.get_passenger_time }}
                </div>
              </div>
              <div class="col-md-5 main_title">
                <i style="color: royalBlue" class="fa fa-taxi fa-2x"></i>
                <span class="fontSize14">完成地點</span>
                <div class="icontimetext">{{ transaction.finish_time }}</div>
              </div>
            </div>
            <div class="row">
              <div ref="mapEl" id="orderMap" class="mapblocksmall">
                目前無地圖資料
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--異常modal-->
    <div
      id="exception"
      class="modal fade bd-example-modal-lg"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title" id="exampleModalLabel">異常處理</h3>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <h4>1.取消此訂單</h4>
              <input
                type="text"
                class="inputstyle fontSize16 col-md-9 col-sm-9 col-xs-9"
                placeholder="請客服人員填寫異常原因"
                v-model="reason"
              />
              <button
                type="button"
                class="btn btn-danger fontSize16"
                style="margin-left: 10px"
                @click="updateOrder('task_cancel')"
              >
                取消訂單
              </button>
            </div>
            <div class="row">
              <h4>2.直接完成訂單毋須填寫理由</h4>
              <button
                type="button"
                class="btn btn-primary fontSize16"
                style="margin-top: 10px"
                @click="updateOrder('task_finish')"
              >
                直接完成訂單
              </button>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              關閉
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reqUpdateInstant, reqInstantById } from '@/api/transaction'
import { Notification, Loading } from 'element-ui'
import { mapLoader } from '@/utils/googleMap'
import { Dispatch, Driver, Passenger, Inquiry, Combine } from './components'
import img_darkMagenta from '@/assets/images/driver-transaction/darkMagenta.png'
import img_khaki from '@/assets/images/driver-transaction/khaki.png'
import img_royalBlue from '@/assets/images/driver-transaction/royalBlue.png'
import img_seaGreen from '@/assets/images/driver-transaction/seaGreen.png'
import img_brown from '@/assets/images/driver-transaction/brown.png'

export default {
  name: 'TransactionDetail',
  components: {
    Dispatch,
    Driver,
    Passenger,
    Inquiry,
    Combine,
  },
  data() {
    return {
      transaction: {},
      driver: {},
      passenger: {},
      inquiry: [],
      map: null,
      reason: '',
    }
  },
  methods: {
    setMarker(map, coordinates, icon) {
      new google.maps.Marker({
        position: {
          lat: coordinates[1],
          lng: coordinates[0],
        },
        map: map,
        icon: icon,
      })
    },
    initMap() {
      const loader = mapLoader()
      loader
        .load()
        .then(async () => {
          const { Map } = await google.maps.importLibrary('maps')
          this.map = new Map(this.$refs.mapEl, {
            zoom: 10,
            // 暫時用maker的座標當地圖的中心點，正確作法應該要讓cookie中的gps是在正確的地點
            center: {
              lat: this.transaction.passenger_getin_gps.coordinates[1],
              lng: this.transaction.passenger_getin_gps.coordinates[0],
            },
            gestureHandling: 'greedy',
          })
        })
        .then(() => {
          if (this.transaction.passenger_getin_gps)
            this.setMarker(
              this.map,
              this.transaction.passenger_getin_gps.coordinates,
              img_brown,
            )
          if (this.transaction.passenger_getoff_gps)
            this.setMarker(
              this.map,
              this.transaction.passenger_getoff_gps.coordinates,
              img_khaki,
            )
          if (this.transaction.driver_order_gps)
            this.setMarker(
              this.map,
              this.transaction.driver_order_gps.coordinates,
              img_darkMagenta,
            )
          if (this.transaction.pick_up_gps)
            this.setMarker(
              this.map,
              this.transaction.pick_up_gps.coordinates,
              img_seaGreen,
            )
          if (this.transaction.acutual_finish_gps)
            this.setMarker(
              this.map,
              this.transaction.acutual_finish_gps.coordinates,
              img_royalBlue,
            )
        })
    },
    async fetch() {
      const loading = Loading.service()
      try {
        const { id } = this.$route.params
        const { data } = await reqInstantById(id, 'havecar')
        this.transaction = data.transaction
        this.driver = data.driver
        this.passenger = data.passenger
        this.inquiry = data.inquiry
        this.initMap()
      } catch (e) {
        console.error(e)
      } finally {
        loading.close()
      }
    },
    async updateOrder(task) {
      try {
        const payload = {
          task: task,
          orderID: this.transaction.id,
        }
        if (task === 'task_cancel') {
          payload.reason = this.reason
        }
        const { result } = await reqUpdateInstant(payload)
        if (result) {
          Notification({
            title: '更新成功',
            type: 'success',
          })
          this.fetch()
          $('#exception').modal('hide')
          return
        }
        Notification({
          title: '更新失敗',
          message: '更新失敗' + result.message,
          type: 'error',
        })
      } catch (e) {
        console.error(e)
        Notification({
          title: '更新失敗',
          message: '更新失敗，稍後再試一次',
          type: 'error',
        })
      }
    },
    onException() {
      $('#exception').modal('show')
    },
  },
  mounted() {
    this.fetch()
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/transaction/TransactionDetail.vue